var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { ref: "agreementContainer", staticClass: "agreementContainer" },
      [
        _c(
          "div",
          { staticStyle: { "text-align": "justify", "padding-right": "10px" } },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "margin-bottom": "24px",
                  "font-weight": "bold",
                },
              },
              [_vm._v("\n        GRUPA PLATFORM AGREEMENT\n      ")]
            ),
            _c("table", { staticClass: "table", attrs: { id: "table" } }, [
              _c("thead", { staticClass: "thead-light" }, [
                _c("tr", { staticStyle: { "font-size": "18px" } }, [
                  _c(
                    "th",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { scope: "col" },
                    },
                    [_vm._v("PARTIES")]
                  ),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.project.project_name)),
                  ]),
                  _c("th", { attrs: { scope: "col" } }, [_vm._v("GRUPA")]),
                ]),
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("td", [_vm._v("Legal Name")]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.project.project_name ? _vm.project.project_name : ""
                      )
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(_vm.companyInfoNew.name))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("Address")]),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.project.address ? _vm.project.address : "") +
                        "\n            "
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(_vm.companyInfoNew.address))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("Contact")]),
                  _c("td", [_vm._v(_vm._s(_vm.clientInfo.name))]),
                  _c("td", [_vm._v(_vm._s(_vm.companyInfoNew.ceo_name))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("Phone")]),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.clientInfo.phone_number
                            ? _vm.clientInfo.phone_number
                            : ""
                        ) +
                        "\n            "
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(_vm.companyInfoNew.phone_number))]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("Email")]),
                  _c("td", [_vm._v(_vm._s(_vm.clientInfo.email))]),
                  _c("td", [_vm._v(_vm._s(_vm.companyInfoNew.email))]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "project-section" }, [
              _c("table", { staticClass: "table", attrs: { id: "table" } }, [
                _vm._m(0),
                _c("tbody", [
                  _vm._m(1),
                  _c("tr", [
                    _c("td", [_vm._v("Service Capacity")]),
                    _c("td", [
                      _vm._v(
                        "\n                Minimum of\n                " +
                          _vm._s(
                            _vm.project.no_of_engineers
                              ? _vm.project.no_of_engineers
                              : ""
                          ) +
                          "\n                engineer(s)\n              "
                      ),
                    ]),
                  ]),
                  _vm._m(2),
                  _c("tr", [
                    _c("td", [_vm._v("Product")]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.project.project_name
                            ? _vm.project.project_name
                            : ""
                        )
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", [_vm._v("Compensation")]),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.project.compensation_id
                              ? _vm.grupaCompensation(
                                  _vm.project.compensation_id
                                )
                              : ""
                          ) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._m(3),
                  _vm._m(4),
                  _vm._m(5),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "compensation-section" }, [
              _c("table", { staticClass: "table", attrs: { id: "table" } }, [
                _vm._m(6),
                _c("tbody", [
                  _c("tr", [
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v("TERMS"),
                    ]),
                    _c("td", [
                      _c("div", [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("CASH :"),
                        ]),
                        _vm._v(
                          "\n                  $" +
                            _vm._s(
                              _vm.project.price
                                ? _vm.project.price.toLocaleString()
                                : ""
                            ) +
                            "\n                  per professional per month Payable in advance, subject to\n                  the terms stated in Section 4 below.\n                "
                        ),
                      ]),
                      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("Equity:"),
                        ]),
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.project.equity) +
                            " percent\n                "
                        ),
                      ]),
                      _vm._m(7),
                      _vm._m(8),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", [_vm._v("Startup Stage")]),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.parseStage(
                              _vm.project.startup.stage_category_id
                            )
                          ) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._m(9),
                ]),
              ]),
            ]),
            _c("br"),
            _c("br"),
            _c("div", { staticClass: "expert-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("SECTION C: EXPERT TEAM"),
              ]),
              _c("table", { staticClass: "table", attrs: { id: "table" } }, [
                _c("thead", { staticClass: "thead-light" }, [
                  _c("tr", { staticStyle: { "font-size": "18px" } }, [
                    _c("th", { attrs: { scope: "col" } }, [_vm._v("Name")]),
                    _c("th", { attrs: { scope: "col" } }, [_vm._v("Email")]),
                    _c("th", { attrs: { scope: "col" } }, [_vm._v("Role")]),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v("Hours/Week"),
                    ]),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v("Cash/Month"),
                    ]),
                    _vm.project.equity
                      ? _c("th", { attrs: { scope: "col" } }, [
                          _vm._v("Equity"),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.teamDetails.members, function (member, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(member.name))]),
                      _c("td", [_vm._v(_vm._s(member.email))]),
                      _c("td", [_vm._v(_vm._s(member.team_role))]),
                      _c("td", [_vm._v(_vm._s(_vm.project.desired_hours))]),
                      _c("td", [
                        _vm._v(
                          "\n                $" +
                            _vm._s(
                              _vm.project.price
                                ? _vm.project.price.toLocaleString()
                                : ""
                            ) +
                            "\n              "
                        ),
                      ]),
                      _vm.project.equity
                        ? _c("td", [_vm._v(_vm._s(_vm.project.equity) + "%")])
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "agreement-section" },
              [
                _c("center", [
                  _c("div", { staticClass: "section-title" }, [
                    _c("h5", [_vm._v("SAAS SERVICES AGREEMENT")]),
                  ]),
                ]),
                _c("div", { staticClass: "section-text" }, [
                  _vm._v(
                    "\n          This SaaS Services Agreement (`Agreement`) is entered into on this\n          " +
                      _vm._s(new Date().getDate()) +
                      " day of\n          " +
                      _vm._s(_vm.monthName(new Date().getMonth())) +
                      " ,\n          " +
                      _vm._s(new Date().getFullYear()) +
                      " (the `Effective Date`) between\n          " +
                      _vm._s(_vm.companyInfoNew.name) +
                      " with a place of business at\n          " +
                      _vm._s(_vm.companyInfoNew.address) +
                      " (`Company`), and the Customer listed\n          above (`Customer`).\n          "
                  ),
                  _c("u", [
                    _vm._v(
                      "This Agreement includes and incorporates the above Order Form, as\n            well as the attached Terms and Conditions, and contains, among\n            other things, warranty disclaimers, liability limitations and use\n            limitations."
                    ),
                  ]),
                  _vm._v(
                    "\n          There shall be no force or effect to any different terms of any\n          related purchase order or similar form even if signed by the parties\n          after the date hereof.\n        "
                  ),
                ]),
                _c("br"),
                _c("div", { staticClass: "signature-container" }, [
                  _c("div", { staticClass: "grupa-signature" }, [
                    _c("div", [
                      _c("h5", [
                        _vm._v(_vm._s(_vm.companyInfoNew.name) + " dba Grupa:"),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "startup-signature" }, [
                    _c("h5", [
                      _vm._v(
                        _vm._s(
                          _vm.project.project_name
                            ? _vm.project.project_name
                            : ""
                        )
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "table",
              {
                staticStyle: {
                  width: "90%",
                  border: "0px",
                  "margin-top": "40px",
                },
                attrs: { cellspacing: "10", cellpadding: "10" },
              },
              [
                _c("tr", [
                  _c("td", { staticStyle: { padding: "20px" } }, [
                    _vm._v("Name: " + _vm._s(_vm.companyInfoNew.ceo_name)),
                  ]),
                  _c("td", { staticStyle: { padding: "20px" } }, [
                    _vm._v(
                      "\n            Name: " +
                        _vm._s(
                          _vm.project.project_name
                            ? _vm.project.project_name
                            : ""
                        ) +
                        "\n          "
                    ),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticStyle: { padding: "20px" } }, [
                    _vm._v("Title: " + _vm._s(_vm.companyInfoNew.role)),
                  ]),
                  _c("td", { staticStyle: { padding: "20px" } }, [
                    _vm._v("Title:"),
                  ]),
                ]),
                _vm._m(10),
                _vm._m(11),
              ]
            ),
            _c(
              "div",
              { staticClass: "terms-conditions" },
              [
                _c("center", [_c("h2", [_vm._v("TERMS AND CONDITIONS")])]),
                _c("div", [_vm._v("1. SAAS SERVICES AND SUPPORT")]),
                _c("div", [
                  _vm._v(
                    "\n          Subject to the terms of this Agreement, Company will use\n          commercially reasonable efforts to provide Customers the Services\n          and customer support as required for the execution. As part of the\n          registration process, the Customer will identify an administrative\n          user name and password for the Customer’s Company account. The\n          Company reserves the right to refuse registration of or cancel\n          passwords it deems inappropriate.\n        "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "restriction-responsibility title-header" },
                  [
                    _vm._v(
                      "\n          RESTRICTIONS AND RESPONSIBILITIES\n        "
                    ),
                  ]
                ),
                _vm._m(12),
                _vm._m(13),
                _vm._m(14),
                _vm._m(15),
              ],
              1
            ),
            _vm._m(16),
            _vm._m(17),
            _vm._m(18),
            _vm._m(19),
            _vm._m(20),
            _vm._m(21),
            _vm._m(22),
            _vm._m(23),
            _vm._m(24),
            _vm._m(25),
            _c(
              "div",
              {
                staticClass: "information-section",
                staticStyle: { "page-break-after": "always" },
              },
              [
                _c("center", [
                  _c("div", { staticClass: "title-header" }, [
                    _vm._v("EXHIBIT B"),
                  ]),
                  _c("div", { staticClass: "title-header" }, [
                    _vm._v("Assignment of Intellectual Property."),
                  ]),
                ]),
                _vm._m(26),
                _c("br"),
                _c("br"),
                _c("div", { staticClass: "section-title" }, [
                  _vm._v(
                    "\n          As used in this Agreement, the term “Pre-Existing Works” shall mean\n          all the Applications developed by the Customer or its associates,\n          copyrights, patents, trade secrets, or other intellectual property\n          rights owned by or licensed to Consultant prior to the date of this\n          Agreement. Ownership of the Pre-Existing Works and work products\n          shall remain with the Customer. Without Customer’s prior written\n          permission, Consultant shall not itself, or through any other party\n          use the Deliverables to provide Services, processing services, or\n          “service bureau” services to third parties; or remove any copyright\n          notices from any Deliverables.\n        "
                  ),
                ]),
              ],
              1
            ),
            _vm._m(27),
            _vm._m(28),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", { staticStyle: { "font-size": "18px" } }, [
        _c("th", { attrs: { colspan: "2", scope: "col" } }, [
          _vm._v("SECTION A: PROJECT"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { width: "120px" } }, [_vm._v("Services")]),
      _c("td", [
        _vm._v("Product development and software engineering services."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Initial Term")]),
      _c("td", [_vm._v("3 months")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Reservation Fee")]),
      _c("td", [
        _vm._v(
          "\n                $500 for booking fees. For an initial consultation,\n                evaluation, ideation, and execution planning.\n              "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Grupa Saas-Fee")]),
      _c("td", [
        _c("b", [
          _vm._v(
            "$0 ( Grupa platform is free to use for management until\n                  April 2022)\n                "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Implementation Services")]),
      _c("td", [
        _vm._v(
          "\n                Company will use commercially reasonable efforts to provide\n                the Customer with the services described in the Statement of\n                Work (“SOW”) attached as Exhibit A hereto (“Implementation\n                Services”), and the Customer shall pay Company the\n                Implementation Fee in accordance with the terms herein.\n              "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", { staticStyle: { "font-size": "18px" } }, [
        _c("th", { attrs: { colspan: "2", scope: "col" } }, [
          _vm._v(
            "\n                SECTION B: COMPENSATION STRUCTURE\n              "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("Equity Awards :"),
      ]),
      _vm._v(
        "\n                  The Customer shall grant to each Consultant Restricted\n                  Common stock based on its fully-diluted capitalization\n                  amount.\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("Equity Vesting Schedule :"),
      ]),
      _vm._v(
        "\n                  Each equity compensation granted to every Consultant, shall\n                  vest on a pro-rata basis monthly over an\n                  "
      ),
      _c("span", { staticStyle: { "font-weight": "bold", color: "red" } }, [
        _vm._v(
          "\n                    18 months period, monthly vesting with a 3-month cliff\n                    period\n                  "
        ),
      ]),
      _vm._v(
        "\n                  , subject to the performance and achievement of targets set\n                  by the Customer in its product roadmap.\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Commitment")]),
      _c("td", [_vm._v("15 to 20hrs per week")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { padding: "20px" } }, [_vm._v("Sign:")]),
      _c("td", { staticStyle: { padding: "20px" } }, [_vm._v("Sign:")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { padding: "20px" } }, [_vm._v("Date:")]),
      _c("td", { staticStyle: { padding: "20px" } }, [_vm._v("Date:")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("\n          1."),
      _c("span", { staticStyle: { "padding-left": "10px" } }, [
        _vm._v(
          "  The Customer hereby engages the Consultant and the\n            Consultant hereby agrees to be engaged by the Customer to develop\n            the Software in accordance with the specifications attached hereto\n            as Exhibit A (the “Statement of Work”). The Consultant shall\n            complete the development of the Software according to the\n            milestones described on the form attached hereto as Exhibit\n            A."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-gap" }, [
      _vm._v("\n          2."),
      _c("span", { staticStyle: { "padding-left": "10px" } }, [
        _vm._v("  The Consultant affirms as follows: "),
        _c("br"),
        _vm._v(
          "\n            a.  that undertaking these Services or any service on\n            the Grupa platform have no conflict with their existing jobs,"
        ),
        _c("br"),
        _vm._v(
          "\n            b.  that they will not use any resources, equipment or\n            licenses owned by any third party to carry out this Service,\n            and"
        ),
        _c("br"),
        _vm._v(
          "\n            c.  that taking up the project will not cause them to\n            reveal any Intellectual Property belonging to any third party or\n            breach any employment agreement to which they are a party\n            to."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "section-gap", staticStyle: { "padding-left": "20px" } },
      [
        _vm._v("\n          1."),
        _c("span", { staticStyle: { "padding-left": "10px" } }, [
          _vm._v(
            "  Customer represents, covenants and warrants that\n            Customer will use the Services only in compliance with Company’s\n            standard published policies then in effect (the “Policy”) and all\n            applicable laws and regulations. Customer hereby agrees to\n            indemnify and hold harmless Company against any damages, losses,\n            liabilities, settlements, and expenses (including without\n            limitation costs and attorneys’ fees) in connection with any claim\n            or action that arises from an alleged violation of the foregoing\n            or otherwise from Customer’s use of Services. Although Company has\n            no obligation to monitor the Customer’s use of the Services,\n            Company may do so and may prohibit any use of the Services it\n            believes may be (or alleged to be) in violation of the\n            foregoing."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "section-gap", staticStyle: { "padding-left": "20px" } },
      [
        _vm._v("\n          2."),
        _c("span", { staticStyle: { "padding-left": "10px" } }, [
          _vm._v(
            "  Except where provided by the Company, the Customer\n            shall be responsible for obtaining and maintaining any equipment\n            and ancillary services needed to connect to, access or otherwise\n            use the Services, including, without limitation, modems, hardware,\n            servers, software, operating systems, networking, web servers, and\n            the like (collectively, “Equipment”). Customer shall also be\n            responsible for maintaining the security of the Equipment,\n            Customer account, passwords (including but not limited to\n            administrative and user passwords) and files, and for all uses of\n            a Customer account or the Equipment with or without Customer’s\n            knowledge or consent."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "property-law", staticStyle: { "margin-top": "15px" } },
      [
        _c("br"),
        _c("div", { staticClass: "title-header" }, [
          _vm._v("1 .CONFIDENTIALITY; PROPRIETARY RIGHTS"),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v("\n          1"),
          _c("span", { staticStyle: { "padding-left": "10px" } }, [
            _vm._v(
              "\n            Each party (the “Receiving Party”) understands that the other\n            party (the “Disclosing Party”) has disclosed or may disclose\n            business, technical or financial information relating to the\n            Disclosing Party’s business (hereinafter referred to as\n            “Proprietary Information” of the Disclosing Party). Proprietary\n            Information of the Company includes non-public information\n            regarding features, functionality, and performance of the Service.\n            Proprietary Information of Customer includes any information\n            relating to the business operations, processes, plans, intentions,\n            product information, know-how, design rights, trade secrets,\n            software, market opportunities, customers and affairs of the\n            Parties, non-public data provided by Customer to Company to enable\n            the provision of the Services (“Customer Data”). The Receiving\n            Party agrees: (i) to take reasonable precautions to protect such\n            Proprietary Information, and (ii) not to use (except in\n            performance of the Services or as otherwise permitted herein) or\n            divulge to any third person any such Proprietary Information. The\n            Disclosing Party agrees that the foregoing shall not apply with\n            respect to any information after five (5) years following the\n            disclosure thereof or any information that the Receiving Party can\n            document (a) is or becomes generally available to the public, or\n            (b) was in its possession or known by it prior to receipt from the\n            Disclosing Party, or (c) was rightfully disclosed to it without\n            restriction by a third party, or (d) was independently developed\n            without the use of any Proprietary Information of the Disclosing\n            Party or (e) is required to be disclosed by law.\n          "
            ),
          ]),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v("\n          2"),
          _c("span", { staticStyle: { "padding-left": "10px" } }, [
            _vm._v(
              "Customer shall own all right, title, and interest in and to the\n            Customer Data, as well as any data that is based on or derived\n            from the Customer Data and provided to Customer as part of the\n            Services. Company shall own and retain all right title, and\n            interest in and to (a) the Services and Software, all\n            improvements, enhancements or modifications thereto, (b) any\n            software, applications, inventions, or other technology developed\n            in connection with Implementation Services or support, and (c) all\n            intellectual property rights related to any of the\n            foregoing."
            ),
          ]),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v("\n          3"),
          _c("span", { staticStyle: { "padding-left": "10px" } }, [
            _vm._v(
              "Notwithstanding anything to the contrary, Company shall have the\n            right to collect and analyze data and other information relating\n            to the provision, use, and performance of various aspects of the\n            Services and related systems and technologies (including, without\n            limitation, information concerning Customer Data and data derived\n            therefrom), and Company will be free (during and after the term\n            hereof) to (i) use such information and data to improve and\n            enhance the Grupa platform and for other development, diagnostic\n            and corrective purposes in connection with the Grupa platform and\n            other Company offerings, and (ii) disclose such data solely in\n            aggregate or other de-identified forms in connection with its\n            business.] No rights or licenses are granted except as expressly\n            set forth herein."
            ),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c("div", { staticClass: "title-header" }, [
        _vm._v("1 .PAYMENT OF FEES"),
      ]),
      _c(
        "div",
        {
          staticClass: "section-text",
          staticStyle: { "padding-left": "20px" },
        },
        [
          _vm._v(
            "\n          1.   Customer will pay Company the then applicable fees\n          described in the Order Form or its Grupa dashboard for the Services\n          and Implementation Services in accordance with the terms therein\n          (the “Fees”). If Customer’s use of the Services exceeds the Service\n          Capacity set forth on the Order Form or otherwise requires the\n          payment of additional fees (per the terms of this Agreement),\n          Customer shall be billed for such usage and Customer agrees to pay\n          the additional fees in the manner provided herein. The company\n          reserves the right to change the Fees or applicable charges and to\n          institute new charges and Fees at the end of the Initial Service\n          Term or than the current renewal term, upon thirty (30) days prior\n          notice to the Customer (which may be sent by email). If Customer\n          believes that Company has billed Customer incorrectly, Customer must\n          contact Company no later than 60 days after the closing date on the\n          first billing statement in which the error or problem appeared, in\n          order to receive an adjustment or credit. Inquiries should be\n          directed to the Company's customer support department.\n        "
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "section-text",
          staticStyle: { "padding-left": "20px" },
        },
        [
          _vm._v(
            "\n          2.   Where payment of fees is not made by direct credit or\n          debit card, the Company may choose to bill through an invoice, in\n          which case, full payment for invoices issued in any given month must\n          be received by the Company thirty (30) days after the mailing date\n          of the invoice. Unpaid amounts are subject to a finance charge of\n          1.5% per month on any outstanding balance, or the maximum permitted\n          by law, whichever is lower, plus all expenses of collection and may\n          result in immediate termination of Service. Customer shall be\n          responsible for all taxes associated with Services other than U.S.\n          taxes based on Company’s net income.\n        "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c("div", { staticClass: "title-header" }, [
        _vm._v("2 .TERM AND TERMINATION"),
      ]),
      _c("div", { staticClass: "section-text" }, [
        _vm._v("\n          1."),
        _c("span", { staticStyle: { "padding-left": "10px" } }, [
          _vm._v(
            "   Subject to earlier termination as provided below,\n            this Agreement is for the Initial Service Term as specified in the\n            Order Form, and shall be automatically renewed for additional\n            periods of the same duration as the Initial Service Term\n            (collectively, the “Term”), unless either party requests\n            termination at least thirty (30) days prior to the end of the\n            then-current term."
          ),
        ]),
      ]),
      _c("div", { staticClass: "section-text" }, [
        _vm._v("\n          2."),
        _c("span", { staticStyle: { "padding-left": "10px" } }, [
          _vm._v(
            "   In addition to any other remedies, either party may\n            also terminate this Agreement by giving 7 days’ notice, if the\n            other party materially breaches any of the terms or conditions of\n            this Agreement. Customers will pay in full for the Services up to\n            and including the last day on which the Services are provided.\n            Upon any termination, Company will make all Customer Data\n            available to Customer for electronic retrieval for a period of\n            thirty (60) days, but thereafter Company may, but is not obligated\n            to, delete stored Customer Data. All sections of this Agreement\n            which by their nature should survive termination will survive\n            termination, including, without limitation, accrued rights to\n            payment, confidentiality obligations, warranty disclaimers, and\n            limitations of liability."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c("div", { staticClass: "title-header" }, [
        _vm._v("3 .WARRANTY AND DISCLAIMER"),
      ]),
      _c("div", { staticClass: "section-text" }, [
        _vm._v(
          "\n          The Company and the Consultant shall use reasonable efforts\n          consistent with prevailing industry standards to maintain the\n          Services in a manner that minimizes errors and interruptions in the\n          Services and shall perform the Services in a professional and\n          workmanlike manner. Services may be temporarily unavailable for\n          scheduled maintenance or for unscheduled emergency maintenance,\n          either by Company or by third-party providers, or because of other\n          causes beyond Company’s reasonable control, but Company shall use\n          reasonable efforts to provide advance notice in writing or by e-mail\n          of any scheduled service disruption. HOWEVER, THE COMPANY DOES NOT\n          WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE; NOR\n          DOES IT MAKE ANY WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED\n          FROM THE USE OF THE SERVICES. EXCEPT AS EXPRESSLY SET FORTH IN THIS\n          SECTION, THE SERVICES AND IMPLEMENTATION SERVICES ARE PROVIDED “AS\n          IS” AND THE COMPANY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED,\n          INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY\n          AND FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "information-section",
        staticStyle: { "margin-top": "45px" },
      },
      [
        _c("div", { staticClass: "title-header" }, [_vm._v("1 .INDEMNITY")]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n          Company shall hold Customer harmless from liability to third parties\n          resulting from infringement by the Service of any United States\n          patent or any copyright or misappropriation of any trade secret,\n          provided Company is promptly notified of any and all threats,\n          claims, and proceedings related thereto and given reasonable\n          assistance and the opportunity to assume sole control over defense\n          and settlement; Company will not be responsible for any settlement\n          it does not approve in writing. The foregoing obligations do not\n          apply with respect to portions or components of the Service (i) not\n          supplied by Company, (ii) made in whole or in part in accordance\n          with Customer specifications, (iii) that are modified after delivery\n          by Company, (iv) combined with other products, processes or\n          materials where the alleged infringement relates to such\n          combination, (v) where Customer continues allegedly infringing\n          activity after being notified thereof or after being informed of\n          modifications that would have avoided the alleged infringement, or\n          (vi) where Customer’s use of the Service is not strictly in\n          accordance with this Agreement. If, due to a claim of infringement,\n          the Services are held by a court of competent jurisdiction to be or\n          are believed by Company to be infringing, Company may, at its option\n          and expense (a) replace or modify the Service to be non-infringing\n          provided that such modification or replacement contains\n          substantially similar features and functionality, (b) obtain for\n          Customer a license to continue using the Service, or (c) if neither\n          of the foregoing is commercially practicable, terminate this\n          Agreement and Customer’s rights hereunder and provide Customer a\n          refund of any prepaid, unused fees for the Service.\n        "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c("div", { staticClass: "title-header" }, [
        _vm._v("1 .LIMITATION OF LIABILITY"),
      ]),
      _c("div", { staticClass: "section-text" }, [
        _vm._v(
          "\n          NOTWITHSTANDING ANYTHING TO THE CONTRARY, EXCEPT FOR BODILY INJURY\n          OF A PERSON, COMPANY AND ITS SUPPLIERS (INCLUDING BUT NOT LIMITED TO\n          ALL EQUIPMENT AND TECHNOLOGY SUPPLIERS), OFFICERS, AFFILIATES,\n          REPRESENTATIVES, CONTRACTORS AND EMPLOYEES SHALL NOT BE RESPONSIBLE\n          OR LIABLE WITH RESPECT TO ANY SUBJECT MATTER OF THIS AGREEMENT OR\n          TERMS AND CONDITIONS RELATED THERETO UNDER ANY CONTRACT, NEGLIGENCE,\n          STRICT LIABILITY OR OTHER THEORY: (A) FOR ERROR OR INTERRUPTION OF\n          USE OR FOR LOSS OR INACCURACY OR CORRUPTION OF DATA OR COST OF\n          PROCUREMENT OF SUBSTITUTE GOODS, SERVICES OR TECHNOLOGY OR LOSS OF\n          BUSINESS; (B) FOR ANY INDIRECT, EXEMPLARY, INCIDENTAL, SPECIAL OR\n          CONSEQUENTIAL DAMAGES; (C) FOR ANY MATTER BEYOND COMPANY’S\n          REASONABLE CONTROL; OR (D) FOR ANY AMOUNTS THAT, TOGETHER WITH\n          AMOUNTS ASSOCIATED WITH ALL OTHER CLAIMS, EXCEED THE FEES PAID BY\n          CUSTOMER TO COMPANY FOR THE SERVICES UNDER THIS AGREEMENT IN THE 12\n          MONTHS PRIOR TO THE ACT THAT GAVE RISE TO THE LIABILITY, IN EACH\n          CASE, WHETHER OR NOT COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF\n          SUCH DAMAGES.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c("div", { staticClass: "title-header" }, [_vm._v("1 .MISCELLANEOUS")]),
      _c("div", { staticClass: "section-text" }, [
        _vm._v(
          "\n          If any provision of this Agreement is found to be unenforceable or\n          invalid, that provision will be limited or eliminated to the minimum\n          extent necessary so that this Agreement will otherwise remain in\n          full force and effect and enforceable. This Agreement is not\n          assignable, transferable, or sublicensable by Customer except with\n          Company’s prior written consent. The Company may transfer and assign\n          any of its rights and obligations under this Agreement without\n          consent. This Agreement is the complete and exclusive statement of\n          the mutual understanding of the parties and supersedes and cancels\n          all previous written and oral agreements, communications, and other\n          understandings relating to the subject matter of this Agreement, and\n          all waivers and modifications must be in a writing signed by both\n          parties, except as otherwise provided herein. No agency,\n          partnership, joint venture, or employment is created as a result of\n          this Agreement and the Customer does not have any authority of any\n          kind to bind the Company in any respect whatsoever. In any action or\n          proceeding to enforce rights under this Agreement, the prevailing\n          party will be entitled to recover costs and attorneys’ fees. All\n          notices under this Agreement will be in writing and will be deemed\n          to have been duly given when received if personally delivered; when\n          receipt is electronically confirmed, if transmitted by facsimile or\n          e-mail; the day after it is sent for next day delivery by recognized\n          overnight delivery service; and upon receipt, if sent by certified\n          or registered mail, return receipt requested. This agreement shall\n          not be modified or amended except by mutual agreement of the\n          parties.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "information-section",
        staticStyle: { "margin-top": "34px" },
      },
      [
        _c("div", { staticClass: "title-header" }, [
          _vm._v("9 . FORCE MAJEURE"),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            '\n          If the performance of this Agreement or any obligation under this\n          Agreement is prevented, restricted, or interfered with by causes\n          beyond either Party\'s reasonable control ("Force Majeure"), and if a\n          Party is unable to carry out its obligations and give the other\n          Party prompt written notice of such an event to the Customer and\n          Company within two days of such occurrence of a Force Majeure event,\n          then the obligations of the Party invoking this provision shall be\n          suspended to the extent necessary by such an event. The term Force\n          Majeure shall include, without limitation, acts of God, fire,\n          explosion, vandalism, storm or other similar occurrence, orders or\n          acts of military or civil authority or by national emergencies,\n          insurrections, riots, or wars, or strikes, lock-outs, work\n          stoppages, or other labor disputes. The excused party shall use\n          reasonable efforts under the circumstances to avoid or remove such\n          causes of non-performance and shall proceed to perform with\n          reasonable dispatch whenever such causes are removed or ceased. An\n          act or omission shall be deemed within the reasonable control of a\n          party if committed, omitted, or caused by such party, or its\n          employees, officers, agents, or affiliates.\n        '
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c("div", { staticClass: "title-header" }, [_vm._v("10. GOVERNING LAW")]),
      _c("div", { staticClass: "section-text" }, [
        _vm._v(
          "\n          This Agreement shall be governed by the laws of the State of\n          Delaware without regard to its conflict of laws provisions. Any\n          disputes arising between the parties shall be resolved amicably\n          amongst themselves and where amicable resolution is not reached for\n          45 days, the parties shall be referred to mediation or the Courts of\n          Chancery, Delaware.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c(
        "div",
        {
          staticClass: "title-header",
          staticStyle: { "padding-left": "20px" },
        },
        [_vm._v("EXHIBIT A")]
      ),
      _c(
        "div",
        {
          staticClass: "title-header",
          staticStyle: { "padding-left": "20px" },
        },
        [
          _vm._v(
            "\n          Statement of Work - Job to be performed\n        "
          ),
        ]
      ),
      _c("div", { staticClass: "padding:10px;" }, [
        _c("div", [_vm._v("1.  Product Planning")]),
        _c("div", [_vm._v("2.  Design Sprint")]),
        _c("div", [
          _vm._v(
            "\n            3.  Custom product development work: Iterative product\n            development ( based on agreed product roadmap )\n          "
          ),
        ]),
        _c("div", [
          _vm._v(
            "\n            4.  Platform Production Management: Workflow system to\n            manage\n          "
          ),
        ]),
        _c("div", { staticStyle: { "padding-left": "20px" } }, [
          _c("div", [_vm._v("●  Product Roadmapping")]),
          _c("div", [_vm._v("●  Product Engineering")]),
          _c("div", [_vm._v("●  Execution Management")]),
        ]),
        _c("div", [
          _vm._v(
            "\n            5.  Delivery Intelligence: system to recommend and track\n            timeline.\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-text" }, [
      _vm._v(
        "\n          Subject to receipt of full payment from Customer for work done,\n          Customer shall own, and Consultant hereby irrevocably transfers to\n          Customer, all rights, titles, and interests in and to all\n          Deliverables created by Consultant for Customer, as set forth in the\n          applicable SOW, and any intellectual property rights connected\n          therewith, including, but not limited to all ideas, inventions,\n          discoveries, know-how, computer programs, improvements, methods,\n          developments, and other creative works and works of authorship,\n          whether or not patentable or copyrightable, conceived or made or\n          reduced to practice (whether solely or with the participation of\n          others) by Consultant. Consultant shall not retain the right to\n          reuse or incorporate, without the written consent of Customer, its\n          technology, Pre-existing works, work product, and intellectual\n          property provided in the Deliverables or the development of the\n          Deliverables. If any Deliverables falls within the definition of\n          “work made for hire” in the U. S. Copyright Act, 17 U.S.C. §101 et\n          seq., then for purposes of this Agreement such Deliverables shall be\n          deemed to be a “work made for hire,” the copyright of which shall be\n          owned solely and exclusively by Customer. If Consultant would be\n          deemed to retain by operation of law or otherwise any intellectual\n          property rights in any such Deliverables, then Consultant hereby\n          assigns and transfers all such retained intellectual property rights\n          to Customer and its successors. where the Consultant has retained\n          any rights in the Deliverables for themselves, or in the event that\n          the Consultant is not available to execute any such documents to\n          this effect, when required, the Consultant irrevocably appoints the\n          Company as its attorney-in-fact to execute all such documents on its\n          behalf. "
      ),
      _c("br"),
      _vm._v(
        "\n          For purposes of this paragraph, the term “Deliverables” shall mean\n          an item to be delivered to the Customer as part of an SOW and shall\n          exclude any Consultant or third party proprietary technology\n          (including software, methodologies, and tools) already in existence\n          at the time of this Agreement, and which has not been developed\n          under this Agreement for Customer. Notwithstanding the foregoing,\n          Consultant will provide Customer with prior written notice\n          identifying any such Consultant or third party proprietary\n          technology to be provided to Customer under any Statement of Work.\n          In such instances, title and full ownership rights shall remain with\n          Consultant or such third party and Consultant hereby grants a fully\n          paid, perpetual, irrevocable license to Customer to use, modify,\n          create derivative works and otherwise commercially exploit\n          Consultant’s proprietary technology in conjunction with the\n          Deliverables.\n        "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c("div", { staticClass: "title-header" }, [
        _vm._v("OBLIGATIONS OF THE PARTIES"),
      ]),
      _c(
        "div",
        {
          staticClass: "title-header",
          staticStyle: { "padding-left": "20px" },
        },
        [_vm._v("\n          1.1 OBLIGATIONS OF THE CONSULTANT\n        ")]
      ),
      _c("div", { staticStyle: { "padding-left": "40px" } }, [
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.1.1 Develop products or software in line with the contents of\n            the Statement of Work, and shall unfailingly make daily and weekly\n            stand-ups to the Customer.\n          "
          ),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.1.2 Provide effective communication to the Customer regarding\n            the Product and any queries or questions that may arise;\n          "
          ),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.1.3 Designates a Lead Consultant who will be the primary contact\n            for the Customer.\n          "
          ),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.1.4 Be required to respond to any questions, issues, queries,\n            and or concerns within 24 hours of communication from the Customer\n            regarding documentation and requirements.\n          "
          ),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.1.5 work together in consensus to achieve set company goals and\n            targets.\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-section" }, [
      _c(
        "div",
        {
          staticClass: "title-header",
          staticStyle: { "padding-left": "20px" },
        },
        [_vm._v("\n          1.2 OBLIGATIONS OF THE CUSTOMER\n        ")]
      ),
      _c("div", { staticStyle: { "padding-left": "40px" } }, [
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.2.1 immediately upon execution of this Agreement, provide all\n            relevant information including but not limited to the scope of\n            work for this Product and other requirements pertaining to the\n            Product.\n          "
          ),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.2.2. within 24 hours of communication from the team required to\n            respond to questions, issues, queries, and or concerns regarding\n            documentation and requirements\n          "
          ),
        ]),
        _c("div", { staticClass: "section-text" }, [
          _vm._v(
            "\n            1.2.3 promptly and upon completion of the Product pay, the full\n            and final Consideration based on the Grupa.io service plan\n            selected.\n          "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }